// TypeScript declarations for global window properties
declare global {
  interface Window {
    __TAURI__?: Record<string, unknown>;
    Capacitor?: {
      getPlatform(): string;
    };
  }
}

// Platform detection utilities
export const platform = {
  // Desktop detection
  isMacOS: typeof window !== 'undefined' && window.__TAURI__,
  isDesktop: typeof window !== 'undefined' && window.__TAURI__,
  
  // Mobile detection
  isiOS: typeof window !== 'undefined' && window.Capacitor?.getPlatform() === 'ios',
  isMobile: typeof window !== 'undefined' && !!window.Capacitor,
  
  // Web detection
  isWeb: typeof window !== 'undefined' && !window.__TAURI__ && !window.Capacitor,
  
  // Apple ecosystem
  isApple: (typeof window !== 'undefined' && window.__TAURI__) || 
           (typeof window !== 'undefined' && window.Capacitor?.getPlatform() === 'ios'),
  
  // Get current platform
  current: (() => {
    if (typeof window === 'undefined') return 'server';
    if (window.__TAURI__) return 'macos';
    if (window.Capacitor?.getPlatform() === 'ios') return 'ios';
    return 'web';
  })()
};

// Platform-specific configuration
export const platformConfig = {
  macos: {
    name: 'macOS Desktop',
    features: ['notifications', 'autoUpdates', 'systemTray', 'globalShortcuts'],
    analytics: false, // Skip web analytics
    tabSync: false,   // No tab sync needed
  },
  ios: {
    name: 'iOS Mobile',
    features: ['pushNotifications', 'haptics', 'statusBar', 'splashScreen'],
    analytics: true,  // Mobile analytics
    tabSync: false,   // No tab sync needed
  },
  web: {
    name: 'Web Browser',
    features: ['analytics', 'tabSync', 'broadcastChannel'],
    analytics: true,
    tabSync: true,
  }
}; 